import React from 'react';
import { getFileName } from '../utils';

const GenericImage = ({
	className,
	src,
	disableInteraction=false
}) => {
	const interactionHandlers = {};

	if (disableInteraction) {
		interactionHandlers.onTouchStart = (e) => e.preventDefault();
		interactionHandlers.onTouchEnd = (e) => e.preventDefault();
		interactionHandlers.onClick = (e) => e.preventDefault();
	}

	return (
		<img 
			className={className} 
			src={src} 
			alt={getFileName(src)}
			{...interactionHandlers} />
	);
};

export default GenericImage;